<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="优惠券搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入优惠券名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" style="margin-left: 40px;" @click="editBtn('')">添加优惠券</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="couponName"
            label="优惠券名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="couponType"
            label="优惠券类型">
            <template slot-scope="scope">
              <span v-if="scope.row.couponType === 1">商城通用券</span>
              <span v-else-if="scope.row.couponType === 2">商城满减券</span>
              <span v-else-if="scope.row.couponType === 3">商城品类通用券</span>
              <span v-else-if="scope.row.couponType === 4">商城品类满减券</span>
              <span v-else-if="scope.row.couponType === 5">商城商品券</span>
              <span v-else-if="scope.row.couponType === 6">门店通用券</span>
              <span v-else-if="scope.row.couponType === 7">门店满减券</span>
              <span v-else-if="scope.row.couponType === 8">单门店通用券</span>
              <span v-else-if="scope.row.couponType === 9">单门店满减券</span>
              <span v-else-if="scope.row.couponType === 10">门店单品券</span>
              <span v-else-if="scope.row.couponType === 11">多门店通用券</span>
              <span v-else-if="scope.row.couponType === 12">多门店满减券</span>
              <span v-else-if="scope.row.couponType === 13">全局通用券</span>
              <span v-else-if="scope.row.couponType === 14">全局满减券</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="couponMoney"
            label="优惠券金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" class="mt-green">开启</span>
              <span v-else class="mt-red">禁用</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="sendUserBtn(scope.row.id)" type="text" size="small">发放</el-button>
              <el-button @click="getRecordBtn(scope.row.id)" type="text" size="small">领取记录</el-button>
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 选择用户发放优惠券弹窗 -->
    <el-dialog
      title="选择用户"
      :visible.sync="sendUserShow"
      width="960px">
      <el-form :model="searchSendForm" inline ref="searchSendForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="用户搜索：" prop="name">
          <el-input class="mt-search-width" v-model="searchSendForm.name" placeholder="请输入用户昵称/手机号"></el-input>
          <el-button type="primary" style="margin-left: 12px;" @click="searchSendTopBtn">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        border
        :data="userList"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          align="center"
          prop="id"
          label="ID">
        </el-table-column>
        <el-table-column
          align="center"
          prop="headPicture"
          label="头像">
          <template slot-scope="scope">
            <el-image
              style="width: 40px;height:40px;border-radius: 40px;"
              :src="scope.row.headPicture == null ? imgServer+'no_img.png' : scope.row.headPicture"
              :preview-src-list="[scope.row.headPicture]"
              fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="nickName"
          label="昵称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机号">
        </el-table-column>
      </el-table>
      <div class="mt-page-bottom flex-end-row">
        <pagination :total="userPageTotal" :page="userCurrentPage" :limit="userLimitLength" @pagination="userHandleCurrentChange" />
      </div>
      <div class="flex-end-row" style="margin-top:24px;">
        <el-button type="primary" @click="userSureBtn">确认选择</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryCouponPageList, removeCouponById, queryMinAppUserPageList, saveCouponReceiveLogBatch } from '@/api/coupon'
export default {
  name: 'Coupon',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // 选择用户发放优惠券弹窗
      sendUserShow:false,
      infoId:'',
      searchSendForm:{
        name:''
      },
      userList:[],
      userCurrentPage:1,
      userLimitLength: this.$limitLength,
      userPageTotal:0,
      multipleSelection:[]
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryCouponPageList({ goodsName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 选择用户发放优惠券弹窗-打开操作
    sendUserBtn (infoId) {
      this.infoId = infoId;
      this.multipleSelection = [];
      this.searchSendForm.name = '';
      this.userCurrentPage = 1;
      this.userGetInfoList();
      this.sendUserShow = true;
    },
    // 选择用户发放优惠券弹窗-搜索操作
    searchSendTopBtn(){
      this.userCurrentPage = 1;
      this.userGetInfoList();
    },
    // 选择用户发放优惠券弹窗-选择用户操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 选择用户发放优惠券弹窗-确认选择
    userSureBtn(){
      var multipleSelection = this.multipleSelection;
      var infoId = this.infoId;
      if(multipleSelection.length == 0){
        this.$message.error('请选择用户');
        return false;
      }
      var userIdList = [];
      multipleSelection.forEach(function(item){
        userIdList.push(item.id);
      });
      var that = this;
      saveCouponReceiveLogBatch({couponId:infoId,userIdList:userIdList}).then((res) => {
          if (res.errorCode === '0000') {
            that.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.searchSendForm.name = '';
                that.sendUserShow = false;
              }
            })
          }
          if (res.errorCode === '1001') {
            that.$message.error(res.msg)
          }
      })
    },
    // 选择用户发放优惠券弹窗-获取数据
    userGetInfoList () {
      let that = this
      let searchName = that.searchSendForm.name
      let page = that.userCurrentPage
      queryMinAppUserPageList({ webSearchStr: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.userList = data
          that.userPageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.userList = []
          that.userPageTotal = res.total
        }
      })
    },
    // 选择用户发放优惠券弹窗-当前页码操作
    userHandleCurrentChange(val){
      this.userCurrentPage = val.page;
      this.userLimitLength = val.limit;
      this.userGetInfoList();
    },
    // 跳转领取记录页面
    getRecordBtn (infoId) {
      this.$router.push({path: '/coupon_get_record', query: {dataId: infoId}})
    },
    /* 编辑 */
    editBtn (infoId) {
      this.$router.push({path: '/coupon_add', query: {dataId: infoId}})
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeCouponById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/coupon/Coupon.vue